<div class="flex h-full w-full flex-col gap-2 p-2">
  <button
    mat-flat-button
    (click)="addGrid()"
    color="primary"
    class="big w-full"
  >
    <mat-icon>add</mat-icon>{{ 'Aggiungi griglia' | siaTranslate }}
  </button>
  <div
    class="flex flex-grow flex-col gap-2 overflow-auto"
    cdkDropList
    cdkDropListOrientation="vertical"
    (cdkDropListDropped)="onDrop($event)"
  >
    @for (grid of configuration.grids; track $index) {
      <div
        class="surface-low flex flex-row items-center gap-1 rounded-xl p-2"
        cdkDrag
      >
        <div class="flex flex-grow flex-row flex-wrap gap-2">
          <sia-select-box
            [label]="'Griglia' | siaTranslate"
            [selectBoxOptions]="{
              disableEmptyElement: true,
              dbKey: 'component.V_SiaGridComponents',
              value: grid.gridId,
            }"
            (valueChanged)="onGridChanged(grid)"
            [(value)]="grid.gridId"
            class="!w-[calc(33.33%-.5rem)]"
          ></sia-select-box>
          <sia-text-box
            [label]="'Altezza minima (px)' | siaTranslate"
            [(value)]="grid.minHeight"
            class="!w-[calc(33.33%-.5rem)]"
          ></sia-text-box>
          @if (gridProperties && gridProperties.length > 0) {
            <select-box-multi
              [(value)]="grid.hideUntilValueFor"
              [selectBoxOptions]="{
                disableEmptyElement: true,
                fixedDataSource: gridProperties,
                value: grid.hideUntilValueFor,
              }"
              [label]="'Valori necessari' | siaTranslate"
              class="!w-[calc(33.33%-.5rem)]"
            ></select-box-multi>
          }
          <sia-check-box
            [label]="'Abilita compattamento' | siaTranslate"
            [(value)]="grid.allowCompact"
            class="!w-[calc(33.33%-.5rem)]"
          ></sia-check-box>
          <sia-check-box
            [label]="'Mostra sempre testata' | siaTranslate"
            [(value)]="grid.showHeaderGrid"
            class="!w-[calc(33.33%-.5rem)]"
          ></sia-check-box>
          <sia-check-box
            [label]="'Nascondi filtri testata' | siaTranslate"
            [(value)]="grid.hideHeaderFilters"
            class="!w-[calc(33.33%-.5rem)]"
          ></sia-check-box>
          @if (grid.allowCompact) {
            <sia-check-box
              [label]="'Nascondi Frecce' | siaTranslate"
              [(value)]="grid.hideArrows"
              class="!w-[calc(33.33%-.5rem)]"
            ></sia-check-box>
          }

          <mat-divider class="w-full"></mat-divider>
          <button mat-button (click)="addBindingProperty(grid)" class="w-full">
            <mat-icon>add</mat-icon>
            {{ 'Proprietà di sincronizzazione' | siaTranslate }}
          </button>
          @for (binding of grid.bindingProperties; track $index) {
            <div
              class="bg-primary-container flex w-[calc(50%-.5rem)] items-center gap-1 rounded-xl p-2"
            >
              @if (grid.dataFields && grid.dataFields.length > 0) {
                <sia-select-box
                  [label]="'Valore da recuperare' | siaTranslate"
                  [selectBoxOptions]="{
                    disableEmptyElement: true,
                    value: binding.propertyName,
                    fixedDataSource: grid.dataFields,
                  }"
                  [(value)]="binding.propertyName"
                  class="flex-1"
                ></sia-select-box>
              }
              <sia-text-box
                [label]="'Nome parametro da passare' | siaTranslate"
                [(value)]="binding.bindingName"
                (valueChanged)="setGridProperties()"
                class="flex-1"
              ></sia-text-box>
              <button
                mat-icon-button
                (click)="removeBindingProperty(grid, $index)"
                class="error"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }

          <mat-divider class="w-full"></mat-divider>
          <button mat-button (click)="addSessionProperty(grid)" class="w-full">
            <mat-icon>add</mat-icon>
            {{ 'Parametri sessione' | siaTranslate }}
          </button>
          @for (sessionProperty of grid.sessionProperties; track $index) {
            <div
              class="bg-primary-container flex w-[calc(50%-.5rem)] items-center gap-1 rounded-xl p-2"
            >
              @if (grid.dataFields && grid.dataFields.length > 0) {
                <sia-select-box
                  [label]="'Valore da recuperare' | siaTranslate"
                  [selectBoxOptions]="{
                    disableEmptyElement: true,
                    value: sessionProperty.propertyName,
                    fixedDataSource: grid.dataFields,
                  }"
                  [(value)]="sessionProperty.propertyName"
                  class="flex-1"
                ></sia-select-box>
              }
              <sia-text-box
                [label]="'Nome parametro sessione' | siaTranslate"
                [(value)]="sessionProperty.bindingName"
                class="flex-1"
              ></sia-text-box>
              <button
                mat-icon-button
                (click)="removeSessionProperty(grid, $index)"
                color="accent"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
        <button
          mat-icon-button
          (click)="removeGrid($index)"
          color="stroked big"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }
  </div>
</div>
